export default __webpack_public_path__ + "static/media/image1.e737f5e5.png";